import React, { Component } from "react";
import PropTypes from "prop-types";

import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { AIRCRAFT_APPLICATION } from "MODULES/parts/constants";
import Form from "./Form";

export default class Create extends Component {
  constructor() {
    super();
    this.reset = this.reset.bind(this);
  }

  state = {
    type: AIRCRAFT_APPLICATION
  };

  updateType = type => this.setState({ type });

  reset = () => this.setState({ type: AIRCRAFT_APPLICATION });

  render() {
    const { open, close, id } = this.props;
    const { type } = this.state;

    const closeAndReset = () => {
      close();
      this.reset();
    };

    return (
      <div>
        <Modal open={open} close={closeAndReset} dialogClass="modal-sm">
          <Header>
            <Close close={closeAndReset} />
            <h4 className="modal-title">Add a New Application</h4>
          </Header>
          <Form
            close={closeAndReset}
            type={type}
            updateType={this.updateType}
            id={id}
          />
        </Modal>
      </div>
    );
  }
}

Create.propTypes = {
  id: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Applications/Create.jsx